import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmClockIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmClockIcon = ({ className, ...props }: EmClockIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_262_44912)">
      <path
        d="M11 21.3125C16.6954 21.3125 21.3125 16.6954 21.3125 11C21.3125 5.30456 16.6954 0.6875 11 0.6875C5.30456 0.6875 0.6875 5.30456 0.6875 11C0.6875 16.6954 5.30456 21.3125 11 21.3125Z"
        fill="#98C0D0"
      />
      <path
        d="M10.9999 19.2741C15.5695 19.2741 19.274 15.5696 19.274 11C19.274 6.43036 15.5695 2.72594 10.9999 2.72594C6.43025 2.72594 2.72583 6.43036 2.72583 11C2.72583 15.5696 6.43025 19.2741 10.9999 19.2741Z"
        fill="#FCEBCD"
      />
      <path
        d="M8.64522 2.58843C7.54178 2.90812 5.99662 3.39797 4.34318 5.37281C2.71037 7.32703 2.3735 9.5975 2.26865 11.1633C2.26865 11.1633 1.32506 12.3441 1.28037 12.1241C0.924591 10.4139 1.64303 6.5914 3.52162 4.57015C5.70787 2.2189 8.55068 1.38531 9.5785 1.2289C9.75553 1.2014 8.98037 2.49218 8.64522 2.58843Z"
        fill="#C2E3F0"
      />
      <path
        d="M11.0001 18.8358C15.3277 18.8358 18.8359 15.3276 18.8359 11C18.8359 6.67241 15.3277 3.16422 11.0001 3.16422C6.67251 3.16422 3.16431 6.67241 3.16431 11C3.16431 15.3276 6.67251 18.8358 11.0001 18.8358Z"
        fill="white"
      />
      <path
        d="M11 6.01562V11"
        stroke="#563428"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="0.6875"
      />
      <path
        d="M11.0001 11.8697C11.4804 11.8697 11.8697 11.4803 11.8697 11C11.8697 10.5197 11.4804 10.1303 11.0001 10.1303C10.5197 10.1303 10.1304 10.5197 10.1304 11C10.1304 11.4803 10.5197 11.8697 11.0001 11.8697Z"
        fill="#563428"
      />
      <path
        d="M14.6213 10.988L10.9707 11.012"
        stroke="#563428"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.03125"
      />
      <path
        d="M11 17.1875V18.0469"
        stroke="#6596A3"
        strokeMiterlimit="10"
        strokeWidth="0.859375"
      />
      <path
        d="M11 3.95312V4.8125"
        stroke="#6596A3"
        strokeMiterlimit="10"
        strokeWidth="0.859375"
      />
      <path
        d="M11 17.1875V18.0469"
        stroke="#6596A3"
        strokeMiterlimit="10"
        strokeWidth="0.859375"
      />
      <path
        d="M11 3.95312V4.8125"
        stroke="#6596A3"
        strokeMiterlimit="10"
        strokeWidth="0.859375"
      />
      <path
        d="M4.8125 11H3.95312"
        stroke="#6596A3"
        strokeMiterlimit="10"
        strokeWidth="0.859375"
      />
      <path
        d="M18.0469 11H17.1875"
        stroke="#6596A3"
        strokeMiterlimit="10"
        strokeWidth="0.859375"
      />
      <path
        d="M4.8125 11H3.95312"
        stroke="#6596A3"
        strokeMiterlimit="10"
        strokeWidth="0.859375"
      />
      <path
        d="M18.0469 11H17.1875"
        stroke="#6596A3"
        strokeMiterlimit="10"
        strokeWidth="0.859375"
      />
      <path
        d="M7.90625 16.3591L7.47656 17.1033"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M14.5234 4.89671L14.0938 5.64093"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M7.90625 16.3591L7.47656 17.1033"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M14.5234 4.89671L14.0938 5.64093"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M14.0938 16.3591L14.5234 17.1033"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M7.47656 4.89671L7.90625 5.64093"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M14.0938 16.3591L14.5234 17.1033"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M7.47656 4.89671L7.90625 5.64093"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M16.359 14.0938L17.1032 14.5234"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M4.89661 7.47656L5.64083 7.90625"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M16.359 14.0938L17.1032 14.5234"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M4.89661 7.47656L5.64083 7.90625"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M5.64083 14.0938L4.89661 14.5234"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M17.1032 7.47656L16.359 7.90625"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M5.64083 14.0938L4.89661 14.5234"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
      <path
        d="M17.1032 7.47656L16.359 7.90625"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.515625"
      />
    </g>
    <defs>
      <clipPath id="clip0_262_44912">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmClockIcon;
